module.exports = __webpack_public_path__ + "static/online-assistant-ca17a9c2e490e1c74b00f49a83a4d106.jpg";